import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Card, Col, Flex, Row, Typography, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowRight } from "./../../../assets/icons/arrow-right.svg";
import { ReactComponent as FavoritesStar } from "./../../../assets/icons/favorite-star.svg";
import Fixtures from "./fixtures/Fixtures";
const { Title, Text } = Typography;
const MatchCard = ({
  league,
  showStartDate,
  matchCardClickCallback,
  fixtureClickCallback
}) => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const onLeagueClick = () => {
    matchCardClickCallback == null ? void 0 : matchCardClickCallback();
    navigate(league.id === -1 ? "/favorites" : `/league/${league.id}`);
  };
  return /* @__PURE__ */ jsxs(
    Card,
    {
      style: {
        cursor: "pointer",
        border: "none",
        boxShadow: "none",
        backgroundColor: token.colorBgBase
      },
      styles: { body: { padding: 0 } },
      onClick: onLeagueClick,
      children: [
        /* @__PURE__ */ jsxs(
          Row,
          {
            justify: "space-between",
            align: "middle",
            style: { marginBottom: 10, flexWrap: "nowrap" },
            children: [
              /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(Row, { align: "middle", style: { flexWrap: "nowrap" }, children: [
                /* @__PURE__ */ jsx(
                  Flex,
                  {
                    align: "center",
                    justify: "center",
                    className: "favorites-component-wrapper",
                    style: {
                      display: "flex",
                      cursor: "default",
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      flexShrink: 0,
                      backgroundColor: token.colorWhite,
                      marginRight: "12px",
                      border: "1.5px solid " + token.colorBgActive
                    },
                    children: league.id === -1 ? /* @__PURE__ */ jsx(FavoritesStar, { className: "favorite-star selected" }) : /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: league.iconUrl,
                        alt: league.name,
                        style: {
                          width: "24px",
                          height: "24px"
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsxs("div", { children: [
                  /* @__PURE__ */ jsx(
                    Title,
                    {
                      level: 5,
                      className: "truncate-line",
                      style: {
                        margin: 0,
                        fontWeight: 500,
                        fontSize: token.fontSizeXL
                      },
                      children: /* @__PURE__ */ jsx(Flex, { align: "center", gap: 12, children: /* @__PURE__ */ jsx("span", { children: league.name }) })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      style: {
                        color: token.colorTextSecondary,
                        fontSize: token.fontSizeSM
                      },
                      children: league.country.name
                    }
                  )
                ] })
              ] }) }),
              /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(ArrowRight, { className: "stroke-base" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Fixtures,
          {
            fixtures: league.fixtures,
            showStartDate,
            fixtureClickCallback
          }
        )
      ]
    }
  );
};
var stdin_default = memo(MatchCard);
export {
  stdin_default as default
};
